import { combineReducers } from 'redux';

import { dataReducer } from './application/redux/data/dataReducer';
import { optionsReducer } from './application/redux/options/optionsReducer';
import { routesReducer } from './application/redux/routes/routesReducer';
import { searchReducer } from './application/redux/search/searchReducer';
import { widgetReducer } from './application/redux/widget/widgetReducer';
import { configReducer, langReducer, loginReducer } from './configuration';
import tokenHandlingReducer from './configuration/tokenHandling/reducer';

export const rootReducer = () =>
    combineReducers({
        data: dataReducer,
        search: searchReducer,
        routes: routesReducer,
        options: optionsReducer,
        widget: widgetReducer,
        config: configReducer,
        lang: langReducer,
        login: loginReducer,
        tokenHandling: tokenHandlingReducer,
    });
